import React, { useState, useEffect } from 'react'
import { Table, FormControl, Button, Collapse } from 'react-bootstrap'
import '../../../index.css'

import { FetchInventory, FetchArticleTypeImages, FetchLocalizedAnalysis } from '../../../fetcher'
import AlertMessage from '../../alertmessages/AlertMessageView'
import { ModalView } from '../../_reusedcomponents/ModalView'
import { RenderImage } from '../../images/ImageView'
import { TransactionContainer } from './TransactionContainer'
import { ExportCSV } from '../../_reusedcomponents/ExportCSVView'
import { parseFloatCurrency } from '../../../utils/formatting/floatnumberparsing'
import { useHandleAlertMessage, useHandleMask } from '../../../utils/togglinghooks'
import { getCsvDataForArticleStock } from '../../../utils/csvdatagetter'
import { useSortStock } from '../../../utils/tablehooks'
import { MaintainStockContainer } from '../addtransactions/MaintainStockContainer'

import moment from 'moment'
import 'moment/locale/de'
moment.locale('de')

/**
 * Container for the stock. Acts similar to transaction container and views.
*/
const StockContainer = () => {
    const { showAlertMessage, openAlert, closeAlert } = useHandleAlertMessage()
    const [showDeliveryDraftMask, handleShowDeliveryDraftMask, handleCloseDeliveryDraftMask, toggleShowDeliveryDraftMask ] = useHandleMask()
    const [showAddStockMask, handleShowAddStockMask, handleCloseAddStockMask, toggleShowAddStockMask] = useHandleMask()
    const [showLowerStockMask, handleShowLowerStockMask, handleCloseLowerStockMask, toggleShowLowerStockMask] = useHandleMask()

    const [fetchedStock, setFetchStock] = useState([])
    const [calculatedStock, setCalculatedStock] = useState([])
    const [articleDataReady, setArticleDataToReady] = useState(false)
    const [childReload, setChildReload] = useState(false)

    const { sortArticlesViaStock, sortArticles } = useSortStock(calculatedStock, setCalculatedStock)

    useEffect(() => {
        setCalculatedStock([...fetchedStock].filter(x => x.ArticleStock.Total !== 0))
    }, [fetchedStock])

    const filteredElementsForCsv = () => {
        let stockForDesigner = [...calculatedStock]

        if (filterInput.trim() != "") {
            let filter = filterInput.toString().toLowerCase()
            stockForDesigner = stockForDesigner.filter(x => (
                JSON.stringify(x.DesignerName).toString()
                + JSON.stringify(x.Name).toString()
                + JSON.stringify(x.Colour).toString()
                + JSON.stringify(x.SalePrice.toString()).toString()
                + JSON.stringify(x.ArticleNumberDesigner).toString()
                + JSON.stringify(x.ArticleIdFaex).toString())
                .toLowerCase().includes(filter))
        }

        console.log("filteredElementsForCsv")
        console.log(stockForDesigner)
        console.log(calculatedStock)

        return stockForDesigner
    }

    const [localizedAnalysis, setLocalizedAnalysis] = useState([])

    const handleSetLocalizedAnalysis = (newLocalizedAnalysis) => {
        const localizedAnalysisCopy = [...localizedAnalysis]
        localizedAnalysisCopy.push(newLocalizedAnalysis[0])

        setLocalizedAnalysis(localizedAnalysisCopy)
    }

    const getLocalizedAnalysis = (articleTypeSysId, size) => {
        FetchLocalizedAnalysis(articleTypeSysId, size, handleSetLocalizedAnalysis, openAlert)
    }

    const [externalExpandedRows, setExternalExpandedRows] = useState([])

    const expandExternalAnalysis = (article) => {
        const expandedRowsCopy = [...externalExpandedRows]
        if (expandedRowsCopy.includes(article)) {
            expandedRowsCopy.splice(expandedRowsCopy.indexOf(article), 1)
        } else {
            expandedRowsCopy.push(article)
            getLocalizedAnalysis(article.ArticleSysId, article.Size)
        }
        setExternalExpandedRows(expandedRowsCopy)
    }

    const getIsExpandedExternalAnalysis = (article) => {
        return (externalExpandedRows.includes(article))
    }

    const [soldExpandedRows, setSoldExpandedRows] = useState([])

    const expandSoldAnalysis = (article) => {
        const expandedRowsCopy = [...soldExpandedRows]
        if (expandedRowsCopy.includes(article)) {
            expandedRowsCopy.splice(expandedRowsCopy.indexOf(article), 1)
        } else {
            expandedRowsCopy.push(article)
            getLocalizedAnalysis(article.ArticleSysId, article.Size)
        }
        setSoldExpandedRows(expandedRowsCopy)
    }

    const getIsExpandedSoldAnalysis = (article) => {
        return (soldExpandedRows.includes(article))
    }

    const getLocalizedExternalDataForRow = (article) => {
        let data = []
        let dataLocalized = localizedAnalysis.find(x => x.FAEXArticleTypeSysId === article.ArticleSysId && x.Size === article.Size)
        if (dataLocalized != undefined) {
            data = dataLocalized.LocalizedAnalysis.AtExternalStorage.filter(x => x.ArticleTypeSysId === article.ArticleSysId && x.SizeValue === article.Size)
        }
        return data
    }

    const getLocalizedSoldDataForRow = (article) => {
        let data = []
        let corrections = []
        let returns = []
        let dataLocalized = localizedAnalysis.find(x => x.FAEXArticleTypeSysId === article.ArticleSysId && x.Size === article.Size)
        if (dataLocalized != undefined) {
            data = dataLocalized.LocalizedAnalysis.Sold.filter(x => x.ArticleTypeSysId === article.ArticleSysId && x.SizeValue === article.Size)
            corrections = dataLocalized.LocalizedAnalysis.CorrectedInSaleTransaction.filter(x => x.ArticleTypeSysId === article.ArticleSysId && x.SizeValue === article.Size)
            returns = dataLocalized.LocalizedAnalysis.Returned.filter(x => x.ArticleTypeSysId === article.ArticleSysId && x.SizeValue === article.Size)
        }
        return [data, corrections, returns]
    }

    const [showEmptyStocks, setShowEmptyStocks] = useState(false)

    const handleShowEmptyStock = () => {
        const emptyStockTemp = !showEmptyStocks
        setShowEmptyStocks(!showEmptyStocks)

        if (emptyStockTemp) {
            let calculatedStock = [...fetchedStock]
            setCalculatedStock(calculatedStock)
        } else {
            let calculatedStock = [...fetchedStock].filter(x => x.ArticleStock.Total !== 0)
            setCalculatedStock(calculatedStock)
        }
    }

    const addingImages = (articleTypeImages) => {
        let copiedFetchedStock = [...fetchedStock]
        articleTypeImages.forEach(image => copiedFetchedStock.filter(x => x.ArticleSysId == image.ArticleTypeSysId).forEach(xfiltered => xfiltered.Image = 'data:image/png;base64,' + image.Data))
        setFetchStock(copiedFetchedStock)
    }

    const [showAllArticles, setShowAllArticles] = useState(false)
    const toggleShowAllArticles = () => {
        if (!showAllArticles) FetchInventory(setFetchStock, openAlert, setArticleDataToReady)
        setShowAllArticles(!showAllArticles)
    }

    const [draftToUpdate, setDraftToUpdate] = useState()
    const [isCorrectionDraft, setIsCorrectionDraft] = useState(false)

    const updateTransactionDraft = (e, transactionDraft) => {
        e.preventDefault()
        setDraftToUpdate(transactionDraft)
        setChildReload(true)

        if (transactionDraft.Type == "CorrectionForNewArrivals") setIsCorrectionDraft(true)
        else setIsCorrectionDraft(false)

        handleShowDeliveryDraftMask(true)
    }

    useEffect(() => {
        if (articleDataReady) {
            FetchArticleTypeImages(fetchedStock.map(x => x.ArticleSysId.toString()), addingImages, openAlert)
        }
    }, [articleDataReady])

    const reload = () => {
        if (showAllArticles) FetchInventory(setFetchStock, openAlert, setArticleDataToReady)
    }

    const ShowTransactionView = () => {
        return (
            <TransactionContainer parentReload={childReload} updateTransactionDraft={updateTransactionDraft} />
        )
    }

    const ShowAllArticles = () => {
        return (
            <>
                <div className="inline">
                    <FormControl className="globalSearch" as="input" placeholder={window.i18n('search')} onChange={handleInput}></FormControl>
                    <Button className="empty-stock-btn filter-button" variant="light" onClick={handleShowEmptyStock}>{showEmptyStocks ? window.i18n('showNonEmptyStocks') : window.i18n('showEmptyStocks')}</Button>
                    <ExportCSV className="" disabled={false} csvData={getCsvDataForArticleStock(filteredElementsForCsv())} fileName={window.i18n('stock')} />
                    <div className="clear"></div>
                </div>
                
                <div className="tablet-transactions-scroll">
                    {filteredElements()}
                </div>
            </>)
    }

    const [filterInput, setFilterInput] = useState("")

    /**
    * Handles the input for the Search Control
    * @param  e - event handler with the users input value
    */
    const handleInput = (e) => {
        let input = e.target.value
        setTimeout(() => setFilterInput(input), 500)
    }

    const filteredElements = () => {
        let filteredItems = [...calculatedStock]
        let filtered = false
        if (filterInput.trim() != "") {
            let filter = filterInput.toString().toLowerCase()

            filteredItems = filteredItems.filter(x => (
                JSON.stringify(x.DesignerName).toString()
                + JSON.stringify(x.Name).toString()
                + JSON.stringify(x.Colour).toString()
                + JSON.stringify(x.SalePrice.toString()).toString()
                + JSON.stringify(x.ArticleNumberDesigner).toString()
                + JSON.stringify(x.ArticleIdFaex).toString())
                .toLowerCase().includes(filter))
            filtered = true
        }

        return returnFilteredElements(filteredItems, filtered == true && filteredItems.length == 0)
    }

    const emptyFilteredList = (isEmpty) => {
        return isEmpty ? window.i18n('errorStocks') : ""
    }

    const returnFilteredElements = (elements, empty) => {
        return (
            <>
                {emptyFilteredList(empty)}
                <Table className='table table-striped table-sm tablet-table ' aria-labelledby="tabelLabel">
                    <thead className="sticky-table-header"><tr>
                        <th>{window.i18n('view')}</th>
                        <th>{window.i18n('articleNumberDesigner')}
                            <a href="" className="sort-link" onClick={(e) => sortArticles(e, 'ArticleNumberDesigner')}>&#8593;&#8595;</a>
                        </th>
                        <th>{window.i18n('articleNumberFaex')}
                            <a href="" className="sort-link" onClick={(e) => sortArticles(e, 'ArticleIdFaex')}>&#8593;&#8595;</a>
                        </th>
                        <th>{window.i18n('articleType')}
                            <a href="" className="sort-link" onClick={(e) => sortArticles(e, 'Name')}>&#8593;&#8595;</a>
                        </th>
                        <th>{window.i18n('colour')}
                            <a href="" className="sort-link" onClick={(e) => sortArticles(e, 'Colour')}>&#8593;&#8595;</a>
                        </th>
                        <th>{window.i18n('size')}
                            <a href="" className="sort-link" onClick={(e) => sortArticles(e, 'Size')}>&#8593;&#8595;</a>
                        </th>
                        <th className="numberColumn">{window.i18n('totalAmount')}
                            <a href="" className="sort-link" onClick={(e) => sortArticlesViaStock(e, 'Total')}>&#8593;&#8595;</a>
                        </th>
                        <th className="numberColumn">{window.i18n('externalAmount')}
                            <a href="" className="sort-link" onClick={(e) => sortArticlesViaStock(e, 'External')}>&#8593;&#8595;</a>
                        </th>
                        <th className="numberColumn">{window.i18n('soldAmount')}
                            <a href="" className="sort-link" onClick={(e) => sortArticlesViaStock(e, 'Sold')}>&#8593;&#8595;</a>
                        </th>
                        <th className="numberColumn">{window.i18n('storageAmount')}
                            <a href="" className="sort-link" onClick={(e) => sortArticlesViaStock(e, 'Storage')}>&#8593;&#8595;</a>
                        </th>
                        <th className="numberColumn">{window.i18n('salePrice')}
                            <a href="" className="sort-link" onClick={(e) => sortArticles(e, 'SalePrice')}>&#8593;&#8595;</a>
                        </th>
                    </tr></thead>

                    <tbody>
                        {elements.map(article =>
                            <>
                                <tr>
                                    <td>{RenderImage(article.Image)}</td>
                                    <td>{article.ArticleNumberDesigner}</td>
                                    <td>{article.ArticleIdFaex}</td>
                                    <td>{article.Name}</td>
                                    <td>{article.Colour}</td>
                                    <td>{article.Size}</td>
                                    <td className="numberColumn">{article.ArticleStock.Total}</td>

                                    {article.ArticleStock.External > 0 ?
                                        <td><Button variant="light" onClick={() => expandExternalAnalysis(article)} aria-controls={article}
                                            aria-expanded={!getIsExpandedExternalAnalysis(article)} className="table-card-header localized-analysis-btn">
                                            {article.ArticleStock.External}
                                        </Button></td> :
                                        <td className="numberColumn">{article.ArticleStock.External}</td>}

                                    {article.ArticleStock.Sold > 0 ?
                                        <td><Button variant="light" onClick={() => expandSoldAnalysis(article)} aria-controls={article}
                                            aria-expanded={!getIsExpandedSoldAnalysis(article)} className="table-card-header localized-analysis-btn">
                                            {article.ArticleStock.Sold}
                                        </Button></td> :
                                        <td className="numberColumn">{article.ArticleStock.Sold}</td>}

                                    <td className="numberColumn">{article.ArticleStock.Storage}</td>
                                    <td className="numberColumn">{parseFloatCurrency(article.SalePrice)}</td>
                                </tr>

                                <Collapse in={getIsExpandedExternalAnalysis(article)}>
                                    <tr>
                                        <td colSpan="6" className="td-nomargin">
                                            <div>
                                                <tr>
                                                    <th className="placeholder-tablecell"></th><th>{window.i18n('external')}</th>
                                                    <th>{window.i18n('where')}</th>
                                                    <th className="numberColumn">{window.i18n('howMany')}</th>
                                                </tr>
                                                {getLocalizedExternalDataForRow(article).map(x => (
                                                    <tr>
                                                        <td className="placeholder-tablecell"></td><td></td>
                                                        <td>{x.StorageName}</td>
                                                        <td className="numberColumn">{x.Amount}</td>
                                                    </tr>
                                                ))}
                                            </div>
                                        </td>
                                    </tr>
                                </Collapse>

                                <Collapse in={getIsExpandedSoldAnalysis(article)}>
                                    <tr>
                                        <td colSpan="7" className="td-nomargin">
                                            <div>
                                                <tr>
                                                    <th className="placeholder-tablecell"></th><th>{window.i18n('sold')}</th>
                                                    <th>{window.i18n('where')}</th>
                                                    <th className="numberColumn">{window.i18n('howMany')}</th>
                                                    <th>{window.i18n('saleDate')}</th>
                                                    <th>{window.i18n('correctedOrReturned')}</th>
                                                </tr>
                                                {getLocalizedSoldDataForRow(article)[0].map(x => (
                                                    <tr>
                                                        <td className="placeholder-tablecell"></td><td></td>
                                                        <td>{x.StorageName}</td>
                                                        <td className="numberColumn">{x.Amount}</td>
                                                        <td>{moment(x.DateOfSaleOrReturn).format("DD.MM.YYYY")}</td>
                                                        <td>{getLocalizedSoldDataForRow(article)[1].find(corrected => corrected.InitialSaleSysId === x.TransactionSysId) !== undefined ? window.i18n('yes')  : ""}</td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                    <th className="placeholder-tablecell"></th><th>{window.i18n('correctedBy')}</th>
                                                    <th>{window.i18n('where')}</th>
                                                    <th className="numberColumn">{window.i18n('howMany')}</th>
                                                    <th>{window.i18n('correctionDate')}</th>
                                                </tr>
                                                {getLocalizedSoldDataForRow(article)[1].map(x => (
                                                    <tr>
                                                        <td className="placeholder-tablecell"></td><td></td>
                                                        <td>{x.StorageName}</td>
                                                        <td className="numberColumn">{x.Amount}</td>
                                                        <td>{moment(x.DateOfSaleOrReturn).format("DD.MM.YYYY")}</td>
                                                    </tr>
                                                ))}
                                            </div>
                                        </td>
                                    </tr>
                                </Collapse>
                            </>
                        )}
                        <tr className="stockReport-row">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>

                            <td>{window.i18n('sum') + ":"} </td>
                            <td className="numberColumn">{elements.map(x => parseInt(x.ArticleStock.Total)).reduce((a, b) => a + b, 0)}</td>
                            <td className="numberColumn">{elements.map(x => parseInt(x.ArticleStock.External)).reduce((a, b) => a + b, 0)}</td>
                            <td className="numberColumn">{elements.map(x => parseInt(x.ArticleStock.Sold)).reduce((a, b) => a + b, 0)}</td>
                            <td className="numberColumn">{elements.map(x => parseInt(x.ArticleStock.Storage)).reduce((a, b) => a + b, 0)}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </Table>
            </>
        )
    }

    return (
        <div>
            <h1 className="title">{window.i18n('stock')}</h1>

            <Button disabled variant="secondary" className="new-transaction-btn form activity-button" onClick={handleShowAddStockMask}>{window.i18n('addStock')}</Button>
            &nbsp;
            <Button disabled variant="secondary" className="new-transaction-btn form activity-button" onClick={handleShowLowerStockMask}>{window.i18n('addStockCorrection')}</Button>
            &nbsp;
            <Button variant="secondary" className="new-transaction-btn form activity-button" onClick={toggleShowAllArticles}>{showAllArticles ? window.i18n('showStockTransactions') : window.i18n('showAllArticles')}</Button>

            {showAllArticles ? ShowAllArticles() : ShowTransactionView()}

            <ModalView handleShow={showAddStockMask} handleClose={handleCloseAddStockMask}
                reload={reload} modalTitle={window.i18n('addStock')} modalBody={<MaintainStockContainer handleCloseMask={handleCloseAddStockMask} lowerStock={false} reloadParent={() => setChildReload(!childReload)} />}
                extendedView={true} formTitle="maintain-stock-submit" />
            <ModalView handleShow={showLowerStockMask} handleClose={handleCloseLowerStockMask}
                reload={reload} modalTitle={window.i18n('addStockCorrection')} modalBody={<MaintainStockContainer handleCloseMask={handleCloseLowerStockMask} lowerStock={true} reloadParent={() => setChildReload(!childReload)} />}
                extendedView={true} formTitle="maintain-stock-submit" />
            <ModalView handleShow={showDeliveryDraftMask} handleClose={handleCloseDeliveryDraftMask}
                reload={reload} modalTitle={isCorrectionDraft ? "Bestandskorrektur-Entwurf bearbeiten" : "Bestands-Entwurf bearbeiten"} modalBody={<MaintainStockContainer handleCloseMask={handleCloseDeliveryDraftMask} lowerStock={isCorrectionDraft} reloadParent={() => setChildReload(!childReload)} draft={draftToUpdate} />}
                extendedView={true} formTitle="maintain-stock-submit" />

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
        </div>
    )
}

export { StockContainer }
